import { date } from '@e3dc-react/shell/Libs/date'
import { NUMBER_OF_DAYS_REQUIRED_SINCE_LAST_PORTAL_UPDATE } from '../consts'

/** check if remindMeLater date is reached */
export const checkIsRemindMeLaterDateReached = (remindMeLater: string): boolean => {
  const remindMeLaterDate = new Date(remindMeLater)
  const now = new Date()

  const isRemindMeLaterDateReached = date.isAfter(now, remindMeLaterDate)

  return isRemindMeLaterDateReached
}

/** check if last portal update is older than certain number of days */
export const checkIsPortalUpdateOldEnough = (portalUpdateDate?: string): boolean => {
  if (!portalUpdateDate) return false

  const updateDate = new Date(portalUpdateDate)
  const requiredThresholdDate = date.subDays(new Date(), NUMBER_OF_DAYS_REQUIRED_SINCE_LAST_PORTAL_UPDATE)

  /* check if last update date took place before certain number of days */
  const isPortalUpdateOldEnough = date.isBefore(updateDate, requiredThresholdDate)
  return isPortalUpdateOldEnough
}
